// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 引入vuex
import store from './store'

Vue.config.productionTip = false

//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import '@css/elementui/index.css';
Vue.use(ElementUI, {size:'small',zIndex:900});

//注册全局组件
import Page from './components/pages/Page.vue'
import FullPage from './components/pages/Fullpage.vue'
import MainPage from './components/pages/Mainpage.vue'
import SubPage from './components/pages/Subpage.vue'
Vue.component('wx-page', Page);
Vue.component('wx-fullpage', FullPage);
Vue.component('wx-mainpage', MainPage);
Vue.component('wx-subpage', SubPage);

//注册全局组件-后台型
import Popup from './components/core/popup/Popup.vue'
import Split from './components/core/split/Split.vue'
import Tabbar from './components/core/tabbar/Tabbar.vue'
import Titlebar from './components/core/titlebar/Titlebar.vue'
import Toolbar from './components/core/toolbar/Toolbar.vue'
Vue.component('wx-popup', Popup);
Vue.component('wx-split', Split);
Vue.component('wx-tabbar', Tabbar);
Vue.component('wx-titlebar', Titlebar);
Vue.component('wx-toolbar', Toolbar);

//注册全局组件-前台型
import MenuTab from '@components/core/menutab/Menutab.vue';
Vue.component('wx-menutab', MenuTab);




require('@/mint-ui/index');


//--------------------公用部分 begin--------------------//
//公用部分
require('@/plugin/toastr/toastr-wx.css');
require('@/plugin/nprogress/nprogress.css');


require('@/plugin/bootstrap/css/bootstrap.css');
import bs from '@/plugin/bootstrap/js/bootstrap.js';
import popup from '@/components/popup/dialog.vue';
Vue.component('v-popup',popup )

//内部公用样式
require('@/css/common.css');
require('@/css/core/color.less');
require('@/css/core/input.less');
require('@/css/core/table.less');
require('@/css/core/msgbox.less');

require('@/css/component/loading.css');


//字体样式
require('@/font/wxfont/iconfont.css');
require('@/font/xefont/iconfont.css');

//--------------------公用部分 end----------------------//


// import vconsole from 'vconsole';
// new vconsole();

//--------------------统计相关 begin--------------------//
// import _stat from '@js/stat';
var statInited = false;

//--------------------统计相关 end----------------------//

//-------- 导入基础库的能力 --------///


//--------//

router.afterEach(function(route){
	window.WXSTAT && WXSTAT.pv();
});

import _common from './js/common';
import _apiUrl from './js/api_url';
import _config from './js/config';
import _util from './libs/qt/util';
import _dateUtil from './libs/qt/dateUtil';

import _pageMaxin from './components/mixins/page';

Vue.prototype._config = _config;
Vue.prototype._common = _common;
Vue.prototype._util = _util;
Vue.prototype._dateUtil = _dateUtil;

Vue.prototype._getUserName = _common.getUserName;
Vue.prototype._getUserInfo = _common.getUserInfo;
Vue.prototype._goLogin = _common.goLogin;

Vue.prototype._postSign = _common.postSign;
Vue.prototype._post = _common.post;

Vue.prototype._ServiceUrls = _apiUrl;


Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});





// WEBPACK FOOTER //
// ./src/main.js